<div>
  <!-- added by ketan 16-01-2026 -->
   <!-- --------------------------- -->
  <!-- <app-loader *ngIf="!groupedClients"></app-loader> -->
  @if (!groupedClients || isFetchingDepartment) {
    <app-loader *ngIf=""></app-loader>
  }
  <!-- ------------------------ -->
  <!-- ended by ketan 16-01-2026 -->

  <ul class="list-group" *ngIf="groupedClients && groupedClients.length === 0">
    <li class="list-group-item">
      No jurisdictions to display
    </li>
  </ul>

  <div *ngFor="let state of groupedClients">
    <h5>{{ state.state }}</h5>
    <ul class="list-group" *ngIf="state.clients && state.clients.length > 0">
      <div class="list-group-item" *ngFor="let client of state.clients">
        <div class="bmd-list-group-col">
          <a (click)="onClientClick(client)" style="cursor: pointer;">
            <p class="list-group-item-heading">
              {{ client.name }}
            </p>
            <p class="list-group-item-text">
              {{ !client.isEnabled ? ' Disabled' : 'Enabled' }}
            </p>
          </a>
        </div>
      </div>
    </ul>
  </div>
  <!-- added by ketan 16-01-2026 -->
   <!-- --------------------------- -->
  <wm-common-confirmation-modal [data]="{
  open:noDepartmentModalOpen,
modalDescp:'No departments found',
modalSubDescp:'Please configure departments',
okBtn:true,
}" (onOkClick)="closeNoDepartmentModal()"></wm-common-confirmation-modal>
<!-- ------------------------ -->
  <!-- ended by ketan 16-01-2026 -->
</div>